module.exports = __webpack_public_path__ + "media/images/official/icon_zoom-4f1c3bd5afb9a6ba6e1084400f646505.png";